module.exports = __webpack_public_path__ + "media/src/images/testimonials/05-38ffa26d1928b481f96aeac60d80a1b3.jpg";